var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"switch-container"},[_c('label',{staticClass:"switch"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"value":_vm.value,"checked":_vm.value},on:{"change":_vm.updateInput}}),_c('span',{staticClass:"slider"})])])}
var staticRenderFns = []

export { render, staticRenderFns }